import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { CategoryClarificationSection } from '../components/sections/CategoryClarificationSection';
import { CoreShiftSection } from '../components/sections/CoreShiftSection';
import { WhatIsTalentIQSection } from '../components/sections/WhatIsTalentIQSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { DeploymentModelSection } from '../components/sections/DeploymentModelSection';
import { DefensibleTechSection } from '../components/sections/DefensibleTechSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ReadinessDefinitionSection } from '../components/sections/ReadinessDefinitionSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FounderInsightSection } from '../components/sections/FounderInsightSection';
import { FinalCTASection } from '../components/sections/FinalCTASection';
import { StarlightBackground } from '../components/ui/StarlightBackground';
export function LandingPage() {
  return <div className="w-full bg-slate-950 min-h-screen relative" data-id="element-319">
      <StarlightBackground data-id="element-320" />
      <div className="relative z-10" data-id="element-321">
        <HeroSection data-id="element-322" />
        <CategoryClarificationSection data-id="element-323" />
        <CoreShiftSection data-id="element-324" />
        <WhatIsTalentIQSection data-id="element-325" />
        <ProblemSection data-id="element-326" />
        <DeploymentModelSection data-id="element-327" />
        <DefensibleTechSection data-id="element-328" />
        <SolutionSection data-id="element-329" />
        <ReadinessDefinitionSection data-id="element-330" />
        <CaseStudiesSection data-id="element-331" />
        <FounderInsightSection data-id="element-332" />
        <FinalCTASection data-id="element-333" />
      </div>
    </div>;
}